export type PublicSecurityStatusLevel =
  | 'in_preparation'
  | 'in_review'
  | 'passed'
  | 'passed_with_warnings';

export const publicSecurityStatusLabels: Record<PublicSecurityStatusLevel, string> = {
  in_preparation: 'Proces wdrażany',
  in_review: 'Kontrola w toku',
  passed: 'Ostatnia kontrola bez wykrytych blockerów',
  passed_with_warnings: 'Kontrola zakończona z zaleceniami',
};

export const publicSecurityStatus = {
  level: 'in_preparation',
  lastReviewDate: null,
  lastReviewLabel: 'Proces kontroli jest wdrażany',
  shortLabel: 'Proces wdrażany',
  scope: [
    'role klienta, serwisu i administratora',
    'dostęp do zgłoszeń naprawy',
    'zdjęcia i załączniki',
    'czat i komunikacja',
    'Firestore Security Rules',
    'Cloud Storage Rules',
    'Cloud Functions',
    'jakość kodu generowanego z pomocą AI',
  ],
  notice:
    'Status opisuje wewnętrzny proces kontroli bezpieczeństwa i jakości kodu. Nie jest formalnym potwierdzeniem bezpieczeństwa ani zewnętrznym testem penetracyjnym.',
} as const;

export type PublicSecurityStatus = typeof publicSecurityStatus;
